export default "__VITE_ASSET__83539487__"